import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { RememberService } from '../../../core/services/remember.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-select-glyphicon',
  templateUrl: './select-glyphicon.component.html',
  styleUrls: ['./select-glyphicon.component.css']
})
export class SelectGlyphiconComponent implements OnInit {
    public setting?: Setting;

    public itemsListGlyphicons: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService, private rememberService: RememberService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1407))[0];
    }

    private async loadGlyphicons(): Promise<void> {
        this.itemsListGlyphicons = await this.datatask.Post(1270);
    }

    public async goBackToPrevious(event: { item: Item; event: MouseEvent }) {
        if (!!this.itemsListGlyphicons) {
            await this.rememberService.remember('w_selectglyphicon.selected_glyphicon', event.item?.item_id);
            this.stateService.back();
        }
    }

    private async init() {
        this.loadSetting();
        this.loadGlyphicons();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    filtervalue: string;
}
